import { Component, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'cmyd-form-error',
  templateUrl: './cmyd-form-error.component.html',
  styleUrls: ["./cmyd-form-error.component.scss"]
})
export class CmydFormErrorComponent {

  @Input() controlName!: NgControl;

  constructor() { }


}
